/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [ { if: { viewport: 'xs' }, tokens: { stackSpace: 4 } } ],
  tokens: { stackGap: 5, stackJustify: 'center', stackSpace: 5 }
}
export default theme
